import { Fill, Style, Stroke, Circle } from 'ol/style';

export const getStyle = (color) => {
  let fillColor = color + '60';
  let style = new Style({
    image: new Circle({
      radius: 5,
      fill: new Fill({
        color: fillColor
      }),
      stroke: new Stroke({
        color: color,
        width: 2
      })
    }),
    fill: new Fill({
      color: fillColor
    }),
    stroke: new Stroke({
      color: color,
      width: 2,
      lineDash: null
    })
  });

  return style;
};

export const getStyleName = (layer, index) => {
  return layer.getStyle(index).getName() !== undefined ? layer.getStyle(index).getName() : layer.getTitle();
};

export const getCloseIcon = (fontSizeEnabled) => (
  <svg
    width={fontSizeEnabled ? 24 * 1.3 : 24}
    fill="white"
    transform="rotate(180)"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="ExpandMoreIcon">
    <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
  </svg>
);
